/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Mdx, Link } from '@ta-interaktiv/contentbricks'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

const ADDITIONAL_SHARES = 32 + 482 + 641
const ARTICLE_ID = '11435150'
const isMobile = window.innerWidth < 600

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
      <ThemeSwitch />

      <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <div className='ui header'>
            <h1>
              Sterberate? Ansteckungs­gefahr? Über­tragungs­wege? Das ist der
              aktuelle Stand der Wissenschaft
            </h1>
            <h2>
                Vor allem das Unbekannte an Covid-19 beunruhigt uns. Forscher
                rund um die Welt arbeiten daran, der neuen Krankheit ein Gesicht
                zu geben. Wir tragen hier die neuesten Erkenntnisse zusammen.
                </h2>
          </div>
          </div>
        </header>


      {/* TODO Replace the following segment with your project cover */}
      {/* <header className='ui vertical very fitted segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Sterberate? Ansteckungs­gefahr? Über­tragungs­wege? Das ist der
              aktuelle Stand der Wissenschaft
              <div className='sub header'>
                Vor allem das Unbekannte an Covid-19 beunruhigt uns. Forscher
                rund um die Welt arbeiten daran, der neuen Krankheit ein Gesicht
                zu geben. Wir tragen hier die neuesten Erkenntnisse zusammen.
              </div>
            </div>
          </h1>
        </div>
      </header> */}

      <div className='ui vertical segment'>
        <div className='ui text container'>
        <div className='ta metainfo'>
              <div className='ta author'>
                <nobr>Marc Brupbacher</nobr>, <nobr>Titus Plattner</nobr>, <nobr>Andreas Moor</nobr>, <nobr>Mathias Lutz</nobr>
              </div>
              <div className='ta updated'>Aktualisiert am 8. April 2020</div>
            </div>

          {/* <div className='ta author'>
            M. Brupbacher, T. Plattner, A. Moor, M. Lutz
          </div>
          <div className='ui text infographic'>Stand: 8. April 2020</div> */}
          <p className='intro'>
            Wir befinden uns immer noch in der ersten Phase der
            Sars-CoV-2-Epidemie. Die Forscher passen bei neuen Daten jeweils
            ihre Ergebnisse und Erkenntnisse an. Einige Studien sind bisher nur
            als Vorab-Publikation (preprint) verfügbar, das heisst, sie wurden
            noch nicht in einem Peer Review-Verfahren begutachtet. Das ist der
            aktuelle Stand der Wissenschaft:
          </p>
        </div>
      </div>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Sterblichkeit</span>
          </h3>
          <Mdx file={require('text/sterblichkeit.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Gefährlichkeit</span>
          </h3>
          <Mdx file={require('text/gefaerhlichkeit.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Dunkelziffer</span>
          </h3>
          <Mdx file={require('text/dunkelziffer.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Verbreitung</span>
          </h3>
          <Mdx file={require('text/verbreitung.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>Inkubationszeit</h3>
          <Mdx file={require('text/inkubationszeit.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Serielles Intervall</span>
          </h3>
          <Mdx file={require('text/interval.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Ansteckungswege</span>
          </h3>
          <Mdx file={require('text/ansteckung.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Schutzmasken</span>
          </h3>
          <Mdx file={require('text/schutzmasken.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Infektiosität</span>
          </h3>
          <Mdx file={require('text/infektiositaet.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Antikörpertests</span>
          </h3>
          <Mdx file={require('text/antikoerpertests.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Symptome und Krankheitsverlauf</span>
          </h3>
          <Mdx file={require('text/krankheitsverlauf.mdx')} />
        </div>
      </section>

      <section id='asymptomatik' className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Asymptomatik</span>
          </h3>
          <Mdx file={require('text/asymptomatik.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Kinder</span>
          </h3>
          <Mdx file={require('text/kinder.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Männer/Frauen</span>
          </h3>
          <Mdx file={require('text/geschlechter.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>Infektionszahlen</h3>
          <Mdx file={require('text/infektionszahlen.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            Szenarien für die Schweiz
          </h3>
          <Mdx file={require('text/schweiz.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>Saisonalität</h3>
          <Mdx file={require('text/saison.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Medikamente und Therapien</span>
          </h3>
          <Mdx file={require('text/medikamente.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>Impfung</h3>
          <Mdx file={require('text/impfung.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>Immunität</h3>
          <Mdx file={require('text/immunitaet.mdx')} />
        </div>
      </section>

      <section className='ui vertical segment'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic header'>
            <span>Mutation</span>
          </h3>
          <Mdx file={require('text/mutation.mdx')} />
        </div>
      </section>

      <div className='ui vertical segment'>
        <div className='ui text container infographic'>
          <div
            style={{
              maxWidth: 375,
              margin: 'auto',
              borderTop: '4px solid #f7cb4a',
              background: '#fff8db',
              padding: 15
            }}
          >
            <div
              style={{
                width: '100%',
                margin: '20px 0 0 0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img
                width='70%'
                src={`//interaktiv.tagesanzeiger.ch/static/logos/${
                  parseHostname().publicationName
                }.svg`}
              />
            </div>
            <h4 className='ui small infographic header'>
              Tagespass verschenken
            </h4>
            <p>
              Hat Ihnen dieser Beitrag gefallen? Dann können Sie ihn gerne
              weiterempfehlen. Mit dem Gutscheincode <strong>24h</strong> kann
              jeder und jede für einen Tag Abo+-Inhalte lesen. Einfach unter{' '}
              <Link
                href={`https://aboshop.${parseHostname().publicationDomain}`}
              >{`aboshop.${parseHostname().publicationDomain}`}</Link>{' '}
              einlösen.
            </p>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        additionalShares={ADDITIONAL_SHARES}
        credits={[
          ['Text', 'Marc Brupbacher, Titus Plattner, Mathias Lutz'],
          ['Umsetzung', 'Andreas Moor']
        ]}
        questions={['Wie informativ war der Beitrag?']}
      >
        <div
          className='ui container'
          style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
        >
          <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
          <ArticleTeasers
            numberOfCards='three'
            articleIds={[
              '172597671179',
              '18727947',
              '29899036',
              '13939717',
              '19483314',
              '13878467',
              '15650041',
              '31092907',
              '10448437'
            ]}
          />
        </div>
      </Footer>
    </div>
  )
}
